import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { useTimeout } from '../useTimeout';
import { copyToClipboard } from './copy';
export var useClipboard = function useClipboard() {
  var alertDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      copyStatus = _React$useState2[0],
      setCopyStatus = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      canCopy = _React$useState4[0],
      setCanCopy = _React$useState4[1];

  React.useEffect(function () {
    setCanCopy(document.queryCommandSupported && document.queryCommandSupported('copy'));
  }, []);
  useTimeout(function () {
    setCopyStatus('idle');
  }, copyStatus !== 'idle' ? alertDuration : 0);
  return {
    canCopy: canCopy,
    copy: copy,
    copyStatus: copyStatus
  };

  function copy(text) {
    try {
      var didCopy = copyToClipboard(text);
      setCopyStatus(didCopy ? 'succeeded' : 'failed');
    } catch (exception) {
      setCopyStatus('failed');
    }
  }
};